// Типові налаштування сеансу (U16): спільні для API (AdminConfig — коли змінну оточення не задано) і вебу (коли
// GET /api/admin/policy недоступний — контроль бездіяльності не вимикається).
/** Типова бездіяльність до завершення сеансу, хв (ТЗ 4.1.5.3 — «задається під час налаштування Системи»). */
export const DEFAULT_SESSION_IDLE_TIMEOUT_MIN = 30;
//# sourceMappingURL=policy.js.map